import Cookies from "js-cookie"
/**
 * Determina o modo atual do tema (claro ou escuro) com base em preferências salvas ou do sistema.
 *
 * @function pegarModoAtual
 * @returns {string} Retorna 'dark' para modo escuro ou 'light' para modo claro.
 *
 * @description
 * Ordem de verificação:
 * 1. Verifica se há uma preferência de tema salva nos cookies
 * 2. Se não encontrar, verifica a preferência de tema do sistema do usuário
 * 3. Em caso de erro, retorna 'light' como padrão
 */

const pegarModoAtual = () => {
  try {
    // Verificar se há uma preferência salva nos cookies
    const cModoPersistido = Cookies.get("preferredTheme")
    if (cModoPersistido) {
      return cModoPersistido
    }

    // Verificar preferência do sistema
    const lPrefereDarkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches

    return lPrefereDarkMode ? "dark" : "light"
  } catch (oErro) {
    console.error("Erro ao determinar o modo do tema:", oErro)
    return "light" // Valor padrão em caso de erro
  }
}

export default pegarModoAtual
